import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Form, Formik } from 'formik'
import SubmitButton from 'components/atoms/buttons/SubmitButton'
import SelectField from 'components/atoms/fields/SelectField'
import formModel, { initialValues, validationSchema } from 'utils/formModels/addStudentModel'
import { useGET_groupCourseSelectQuery, usePOST_createStudentsInGroupCourseMutation } from 'redux/api/groupCoursesApi'
import AddStudentList from 'components/utilized/student/AddStudentList'
import { useErrorAlert } from 'utils/customHooks/useErrorAlert'
import { Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'


const AddStudentForm: FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const {group_course, students} = formModel()

  const [addStudents, {isLoading, isSuccess, error }] = usePOST_createStudentsInGroupCourseMutation()
  useErrorAlert(error)
  
  if(isSuccess)return <>

    <div style={{ textAlign: 'center', paddingTop: '80px', paddingBottom: '80px' }}>
        <div style={{ fontSize: '20px', lineHeight: '24px', fontWeight: '600', marginBottom: '40px' }}>
            {t('common.added-students')}
        </div>
        <Button 
            onClick={() => { 
                navigate('/assignment/add')
            } }
            aria-label={t('common.add-assignment')}
            color='primary'
            variant='contained'
            sx={{ }}>
                {t('common.add-assignment')}
        </Button>
    </div>
  </>

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values: any) => {
        const data = {
          students: values.students.map((s) => { return {
            email: s.email,
            first_name: s.first_name,
            last_name: s.last_name
          } })
        }
        addStudents({id: values?.group_course?.id, body: data})
      }}
    >
          <Form>
            
            <div style={{ maxWidth: '300px' }}>
                <SelectField
                    fieldProps={{ ...group_course }}
                    apiCall={useGET_groupCourseSelectQuery}
                />
            </div>

            <div style={{ border: '1px dashed #333', background: '#f5f5f5', padding: '20px', marginTop: '20px', marginBottom: '20px'}}>
                <AddStudentList fieldProps={{ ...students }}/>
            </div>

            <div style={{ textAlign: 'right' }}>
                <SubmitButton
                    color={'primary'}
                    text={t('common.submit')}
                    sx={{ width: '10rem' }}
                    isLoading={isLoading}
                />
            </div>
          </Form>
    </Formik>
  )
}

export default AddStudentForm

